/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSyncAlt} from '@fortawesome/pro-duotone-svg-icons';

const ButtonSpinnerIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faSyncAlt} spin {...props} />
);

export default ButtonSpinnerIcon;
